import React from 'react';
import { Typography, Box } from '@mui/material';

const WithdrawalRequestDetails = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Détails de la Demande de Retrait
      </Typography>
      <Typography variant="body1">
        Module de détails des demandes de retrait - En cours de développement
      </Typography>
    </Box>
  );
};

export default WithdrawalRequestDetails;

